
import { data } from '~/node_modules/autoprefixer/lib/autoprefixer';

export default {
  name: 'Reports',
  fetchOnServer: false,

  props: {
    companyInfo: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      selectedTab: 0, // Default selected tab index
    }
  },
  computed: {
    securitySymbol() {
      if (this.companyInfo.IsLinked) {
        return this.companyInfo.LinkedSymbol
      }
      return this.$route.params.SecuritySymbol
    },
  },
  methods: {
    selectTab(index) {
      // This method can be used to handle tab selection if needed
      this.selectedTab = index
    },
  },
}
